function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "19",
  height: "13",
  viewBox: "0 0 19 13",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M9.385 0C4.428 0 .59 5.282.427 5.505L0 6.095l.427.588c.162.224 4.002 5.505 8.958 5.505 4.957 0 8.796-5.281 8.959-5.505l.426-.589-.426-.589C18.18 5.282 14.342 0 9.385 0zm0 10.157c-3.047 0-5.77-2.803-6.825-4.063 1.056-1.26 3.758-4.063 6.825-4.063 3.047 0 5.77 2.804 6.826 4.063-1.057 1.26-3.758 4.063-6.826 4.063z",
  fill: "#12002D"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.385 3.047a3.043 3.043 0 00-3.047 3.047 3.043 3.043 0 003.047 3.048 3.043 3.043 0 003.047-3.048 3.043 3.043 0 00-3.047-3.047zm0 4.063a1.006 1.006 0 01-1.016-1.016c0-.568.447-1.015 1.016-1.015s1.016.447 1.016 1.015c0 .57-.447 1.016-1.016 1.016z",
  fill: "#12002D"
})));